<div class="login-inner">
    <app-header ></app-header>
    <div class="pt-5">
        <router-outlet></router-outlet>
        <app-app-accessibility-panel></app-app-accessibility-panel>
    </div>
</div>
<app-footer></app-footer>